export var AgeCategoryType;
(function (AgeCategoryType) {
    AgeCategoryType["ADULT"] = "ADULT";
    AgeCategoryType["TEENAGER"] = "TEENAGER";
    AgeCategoryType["CHILD"] = "CHILD";
    AgeCategoryType["INFANT"] = "INFANT";
})(AgeCategoryType || (AgeCategoryType = {}));
